function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWolontariatIlustracjaBez = function SvgWolontariatIlustracjaBez(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Warstwa 1",
    viewBox: "0 0 99.38 99.38"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h99.38v99.38H0z",
    style: {
      fill: "#f8dacb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h99.38c0 27.43-22.27 49.69-49.69 49.69S0 27.43 0 0",
    style: {
      fill: "#feeae0"
    }
  }));
};
export default SvgWolontariatIlustracjaBez;